import { css } from '@emotion/css';

export const main = css`
  margin-bottom: 1rem;
`;
